export const space = [
  '4px',
  '8px',
  '12px',
  '16px',
  '24px',
  '32px',
  '48px',
  '72px',
  '144px',
] as const
